import state from './NotePhrase/states'
import mutations from './NotePhrase/mutations'
import actions from './NotePhrase/actions'
import getters from './NotePhrase/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
